import { useI18n } from '@experience/i18n';
import ru from '@/features/sorting/i18n/ru';
import { ListSortItemValue } from '@/shared/models';

export const useSortList = () => {
  const { t } = useI18n({
    inheritLocale: true,
    messages: { ru },
  });

  return [
    {
      id: 1,
      label: t(`sorting.${ListSortItemValue.RANK}`),
      value: ListSortItemValue.RANK,
      selected: false,
    },
    {
      id: 2,
      label: t(`sorting.${ListSortItemValue.PUBLISHED_AT}`),
      value: ListSortItemValue.PUBLISHED_AT,
      selected: false,
    },
    {
      id: 3,
      label: t(`sorting.${ListSortItemValue.RATING}`),
      value: ListSortItemValue.RATING,
      selected: false,
    },
  ];
};
